import { createUseStyles } from 'react-jss';

const bezier = 'cubic-bezier(0, 0, 0, 1)';

const useStyles = createUseStyles({
  wrenchZoom: ({ timeout }) => ({
    '&$enterActive': {
      transition: `transform ${timeout}ms ${bezier}, opacity 100ms linear`,
    },
    '&$exitActive': {
      transition: `transform ${timeout}ms ${bezier}, opacity 50ms linear 50ms`,
    },
  }),
  enter: { opacity: '0', transform: 'scale(0.8)' },
  enterActive: { opacity: '1', transform: 'scale(1)' },
  exit: { opacity: '1', transform: 'scale(1)' },
  exitActive: { opacity: '0', transform: 'scale(0.8)' },
});

export default useStyles;
